<template>
  <button class="form-submit-button">
    <slot />
  </button>
</template>
